import { Dialog, Icon, Icons, Intent } from "construct-ui";
import moment from "moment";
import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import FileUploadInputComponent from "../../../components/file/file-upload-input.component";
import QtyNumberInputComponent from "../../../components/posm/goods-movement/qty-number-input.component";
import SelectSiteSearchInputComponent from "../../../components/site/select-site-search-input.component";
import SelectUserComponent from "../../../components/user/select-user.component";
import { formats } from "../../../config/constants";
import goodMovementModel from "../../../models/posm/goods-movement.model";
import { actionApplication, getDetailApplication, saveApplication } from "../../../models/posm/posm-goods-issue-application.model";
import ViewBase from "../../view-base.view";
import RetailQtyExcelUpload from "./retail-qty-upload.view";
import { APPROVAL_STATUSES } from "./posm-goods-issue-application.view";
import POSMAuthorizationModel, { POSM_PERMISSION_KEY } from "../../../models/posm/posm-authority.model";

function UpdatePOSMGoodsIssueApplicationDialog({ attrs: { movementControlCode } }) {
  ViewBase.call(this);

  const DEFAULT_MOVEMENT_DETAIL_INFO = {
    topCateName: null,
    topCateControlCode: null,
    mainCateName: null,
    mainCateControlCode: null,
    modelName: null,
    goodsId: null,
    goodsName: null,
    goodsControlId: null,
    stockQty: null,
    mvgPrice: null,
    warehouseName: null,
    storageName: null,
    isExpiry: null,
    stockDueDate: null,
    expiryDate: null,
    movementTypeName: null,
    movementControlId: null,
    movementDate: null,
    goodsIssueDate: null,
    movementBy: null,
    fromWarehouse: null,
    fromStorageId: null,
    fromStorageName: null,
    channelCode: null,
    channelName: null,
    channelStockQty: null,
    movementQty: null,
    fromStockQty: null,
    approveBy: null,
    approveByName: null,
    approveDate: null,
    approveBy2: null,
    approveByName2: null,
    approveDate2: null,
    editLvl: null,
    approvalStatus: null,
    movementMasterControlId: null,
    remarks: null,
    fileId1: null,
    fileName1: null,
    fileId2: null,
    fileName2: null,
    fileId3: null,
    fileName3: null,
    fileId4: null,
    fileName4: null,
    fileId5: null,
    fileName5: null,
    approveRemarks: null,
    approveRemarks2: null
  }

  const APPROVAL_ACTIONS = {
    APPROVE: 'APP',
    APPROVE2: 'APP2',
    REJECT: 'REJ',
    DELETE: 'DEL',
  }
  const APPROVAL_SAVES = {
    SAVE: APPROVAL_STATUSES.PendingSubmission.code,
    SUBMIT: APPROVAL_STATUSES.PendingApproval.code,
  }

  const UPDATE_GOODS_APPLICATION_FORM_ID = 'CreateGoodsMovementForm';

  let applicationDetailInfo = structuredClone(DEFAULT_MOVEMENT_DETAIL_INFO);
  let fileInputs = {
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
  }
  let maxQty = 0;
  let lastButtonClick = '';
  let isRequesting = false;

  const buildSaveApplicationBody = () => {
    const payload = {
      editMovementControlID: movementControlCode,
      movementBy: applicationDetailInfo.approveBy,
      movementBy2: applicationDetailInfo.approveBy2,
      movementDate: moment(applicationDetailInfo.movementDate).format(formats.apiDateFormat),
      remarks: applicationDetailInfo.remarks,
      approvalStatus: lastButtonClick,
      fileId1: applicationDetailInfo.fileId1,
      fileId2: applicationDetailInfo.fileId2,
      fileId3: applicationDetailInfo.fileId3,
      fileId4: applicationDetailInfo.fileId4,
      fileId5: applicationDetailInfo.fileId5,
      fileInput1: fileInputs[1],
      fileInput2: fileInputs[2],
      fileInput3: fileInputs[3],
      fileInput4: fileInputs[4],
      fileInput5: fileInputs[5],
      'movementDetails[0].ChannelCode': applicationDetailInfo.channelCode,
      'movementDetails[0].StorageId': applicationDetailInfo.fromStorageId,
      'movementDetails[0].QTY': applicationDetailInfo.movementQty,
      'movementDetails[0].GoodsControlId': applicationDetailInfo.goodsControlId,
    }

    let payloadFormData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (!value) {
        return
      }
      payloadFormData.append(key, value)
    })

    return payloadFormData
  }

  const buildActionAppilcationBody = () => {
    const payload = {
      movementControlId: movementControlCode,
      approvalAction: lastButtonClick,
      approvalRemarks: !checkEditLvl1() ? applicationDetailInfo.remarks : !checkEditLvl2() ? applicationDetailInfo.approveRemarks : applicationDetailInfo.approveRemarks2,
      fileId1: applicationDetailInfo.fileId1,
      fileId2: applicationDetailInfo.fileId2,
      fileId3: applicationDetailInfo.fileId3,
      fileId4: applicationDetailInfo.fileId4,
      fileId5: applicationDetailInfo.fileId5,
    }

    let payloadFormData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value || value == 0) {
        payloadFormData.append(key, value)
      } else {
        payloadFormData.append(key, '');
      }
    })

    return payloadFormData
  }

  const manualValidate = () => {
    return true
  }

  const checkEditLvl1 = () => {
    return applicationDetailInfo.editLvl != "1"
  }
  const checkEditLvl2 = () => {
    return applicationDetailInfo.editLvl != "2"
  }
  const checkEditLvl3 = () => {
    return applicationDetailInfo.editLvl != "3"
  }

  const onSubmitButtonsClick = (e) => {
    lastButtonClick = e.target.name;
  }

  const handleSubmit = (e, onClose) => {

    if (!this.validateForm(e)) {
      return
    }

    if (!manualValidate()) {
      return
    }

    if (!isRequesting) {
      handleApplicationRequest(onClose);
    }
  }

  const handleApplicationRequest = (onClose) => {
    isRequesting = true;
    this.showLoading();
    if (Object.values(APPROVAL_ACTIONS).includes(lastButtonClick)) {
      actionApplication(buildActionAppilcationBody())
        .then((result) => {
          if (result.transStatus === 'SUCCESS') {
            this.showMessage(this.getText('EM00000004', 'Success'), this.getText('EM00000004', 'Success'), () => onClose(true))
          } else this.showErrorMessage(result.message ?? result.code, this.getText("EM00000142", "Error"))
        }).catch((error) => {
          this.handleError(error);
        }).finally(() => {
          this.hideLoading();
          isRequesting = false;
        })
    } else {
      saveApplication(buildSaveApplicationBody())
        .then((result) => {
          if (result.transStatus === 'SUCCESS') {
            this.showMessage(this.getText('EM00000004', 'Success'), this.getText('EM00000004', 'Success'), () => onClose(true))
          } else this.showErrorMessage(result.message ?? result.code, this.getText("EM00000142", "Error"))
        }).catch((error) => {
          this.handleError(error);
        }).finally(() => {
          this.hideLoading();
          isRequesting = false;
        })
    }
  }

  const downloadProofFile = (fileId, fileName) => {
    goodMovementModel.downloadProofFile(fileId, fileName)
  }

  const handleChange = (newItem) => {
    applicationDetailInfo = { ...applicationDetailInfo, ...newItem }
  }


  const showDeleteMessage = (e, onClose) => {
    onSubmitButtonsClick(e);
    this.showConfirm(
      this.getText('EM00000265', 'Are you sure you want to delete?'),
      `${this.getText('LT00000135', 'Delete')} - ${movementControlCode}`,
      (action) => {
        if (action === 'YES') {
          handleDeleteMovement(onClose);
        }
      }
    )
  }

  const handleDeleteMovement = (onClose) => {
    this.showLoading();

    actionApplication(buildActionAppilcationBody())
      .then((result) => {
        if (result.transStatus === 'SUCCESS') {
          this.showMessage(this.getText("LT00001077", "Item deleted successfully"), this.getText('EM00000004', 'Success'), () => onClose(true))
        } else this.showErrorMessage(this.getText(result.code, result.message), this.getText("EM00000142", "Error"))
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const getInitData = () => {
    this.showLoading();
    getDetailApplication(movementControlCode)
      .then((result) => {
        handleChange(result[0]);
        maxQty = applicationDetailInfo.fromStockQty + applicationDetailInfo.movementQty;
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading()
      })
  }
  return {
    oninit: ({ attrs: { selectedWarehouseStorageItem } }) => {
      getInitData()
    },
    view: ({ attrs: { isOpen, onClose, } }) => {
      return [m(Dialog, {
        isOpen,
        onClose,
        closeOnOutsideClick: false,
        closeOnEscapeKey: false,
        class: 'cui-dialog-xxl',
        title: this.getText('LT00001309', 'Goods Issue Application') + `(${movementControlCode})`,
        content: [
          m('.card',
            m('.card-body',
              m('form.needs-validation[novalidate]', {
                id: UPDATE_GOODS_APPLICATION_FORM_ID,
                onsubmit: (e) => { handleSubmit(e, onClose) }
              },
                m('.row.g-2',
                  m('.col-md-4',
                    m('label.form-label[for="main"]',
                      this.getText('LT00001266', 'Main')
                    ),
                    m(`input#Main.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.mainName ?? this.getText('LT00000287', 'Home'),
                        title: applicationDetailInfo.mainName ?? this.getText('LT00000287', 'Home')
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="goodsType"]',
                      this.getText('LT00001267', 'Goods Type')
                    ),
                    m(`input#goodsType.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.topCateName + (applicationDetailInfo.topCateControlCode ? `(${applicationDetailInfo.topCateControlCode})` : ''),
                        title: applicationDetailInfo.topCateName + (applicationDetailInfo.topCateControlCode ? `(${applicationDetailInfo.topCateControlCode})` : '')
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="division"]',
                      this.getText('LT00000233', 'Division')
                    ),
                    m(`input#division.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.mainCateName + (applicationDetailInfo.mainCateControlCode ? `(${applicationDetailInfo.mainCateControlCode})` : ''),
                        title: applicationDetailInfo.mainCateName + (applicationDetailInfo.mainCateControlCode ? `(${applicationDetailInfo.mainCateControlCode})` : '')
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="model"]',
                      this.getText('LT00000717', 'Model')
                    ),
                    m(`input#model.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.modelName,
                        title: applicationDetailInfo.modelName
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="basicModel"]',
                      this.getText('LT00001268', 'Basic Model')
                    ),
                    m(`input#basicModel.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.goodsName,
                        title: applicationDetailInfo.goodsName
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="controlNo"]',
                      this.getText('LT00001272', 'Control No')
                    ),
                    m(`input#controlNo.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.goodsControlId
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="totalQty"]',
                      this.getText('LT00001273', 'Total Qty')
                    ),
                    m(`input#totalQty.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.stockQty
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="stockDueDate"]',
                      this.getText('LT00001275', 'Stock Due Date')
                    ),
                    m(`input#stockDueDate.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.stockDueDate ? moment(applicationDetailInfo.stockDueDate).format(formats.dateFormat) : ''
                      }
                    )
                  ),

                  m('.col-md-4',
                    m('label.form-label[for="useDueDate"]',
                      this.getText('LT00001276', 'Use Due Date')
                    ),

                    m(`input#useDueDate.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: (applicationDetailInfo.isExpiry && applicationDetailInfo.expiryDate) ? moment(applicationDetailInfo.expiryDate).format(formats.dateFormat) : ''
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="warehouse"]',
                      this.getText('LT00001269', 'Warehouse')
                    ),
                    m(`input#warehouse.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.warehouseName,
                        title: applicationDetailInfo.warehouseName
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="storageLocation"]',
                      this.getText('LT00001270', 'Storage Location')
                    ),
                    m(`input#storageLocation.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.fromStorageName,
                        title: applicationDetailInfo.fromStorageName
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="storageQty"]',
                      this.getText('LT00001277', 'Storage Qty')
                    ),
                    m(`input#storageQty.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.fromStockQty,
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="Applicant"]',
                      this.getText('LT00001316', 'Applicant')
                    ),
                    m(`input#Applicant.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.movementBy,
                        title: applicationDetailInfo.movementBy
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="ApplicationDate"]',
                      this.getText('LT00001317', 'Application Date')
                    ),
                    m(`input#ApplicationDate.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: moment(applicationDetailInfo.movementDate).format(formats.dateFormat),
                      }
                    )
                  ),
                  m('.col-md-4.position-relative',
                    m('label.form-label.mandatory[for="movementDate"]',
                      this.getText('LT00001256', 'Goods Issue Date')
                    ),
                    checkEditLvl1()
                      ? m(`input#ApplicationDate.form-control.form-control-bg.text-truncate[type=text]`,
                        {
                          disabled: true,
                          value: moment(applicationDetailInfo.goodsIssueDate).format(formats.dateFormat),
                        }
                      )
                      : m(DatePickerComponent, {
                        class: 'form-control',
                        required: true,
                        readonly: true,
                        date: moment(applicationDetailInfo.goodsIssueDate).format(formats.dateFormat),
                        onselect: (e) => {
                          onChange('movementDate', moment(e.detail.date).toISOString());
                        }
                      }),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="storageQty"]',
                      this.getText('LT00001322', 'Approval Status')
                    ),
                    m(`input#storageQty.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.approvalStatus,
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="Applicant"]',
                      this.getText('LT00001239', 'Movement Code')
                    ),
                    m(`input#Applicant.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.movementControlId,
                        title: applicationDetailInfo.movementControlId
                      }
                    )
                  ),
                  m('.col-md-4'),
                  m('.col-md-4.position-relative',
                    m('label.form-label.mandatory[for="approveBy"]',
                      this.getText('LT00001323', 'Approve By')
                    ),
                    m(SelectUserComponent, {
                      default: {
                        userStatusCode: '0001'
                      },
                      required: true,
                      disabled: checkEditLvl1(),
                      multiple: false,
                      onSelect: (selectedUserList) => {
                        handleChange({ approveBy: selectedUserList[0].userID, approveByName: selectedUserList[0].userName })
                      },
                      selectedUserList: [{
                        userID: applicationDetailInfo.approveBy,
                        userName: applicationDetailInfo.approveByName
                      }],
                    }),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                  ),
                  m('.col-md-4.position-relative',
                    m('label.form-label[for="approveDate"]',
                      this.getText('LT00001325', 'Approve Date')
                    ),
                    m(`input#ApplicationDate.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.approveDate ? moment(applicationDetailInfo.approveDate).format(formats.dateFormat) : '',
                      }
                    )
                  ),
                  m('.col-md-8',
                    m(`textarea#approvealRemarks.form-control.form-control-bg`,
                      {
                        disabled: checkEditLvl2(),
                        placeholder: this.getText('LT00001320', 'Approval Remarks 1'),
                        maxlength: 1000,
                        value: applicationDetailInfo.approveRemarks,
                        onchange: (e) => { handleChange({ approveRemarks: e.target.value }) }
                      }
                    )
                  ),
                  m('.col-md-4'),
                  m('.col-md-4.position-relative',
                    m('label.form-label[for="approveBy2"]',
                      this.getText('LT00001324', 'Approve By 2')
                    ),
                    m(SelectUserComponent, {
                      default: {
                        userStatusCode: '0001'
                      },
                      disabled: checkEditLvl1(),
                      multiple: false,
                      onSelect: (selectedUserList) => {
                        handleChange({ approveBy2: selectedUserList[0].userID, approveByName2: selectedUserList[0].userName })
                      },
                      selectedUserList: [{
                        userID: applicationDetailInfo.approveBy2,
                        userName: applicationDetailInfo.approveByName2
                      }],
                    })
                  ),
                  m('.col-md-4.position-relative',
                    m('label.form-label[for="approveDate2"]',
                      this.getText('LT00001326', 'Approve Date 2')
                    ),
                    m(`input#ApplicationDate.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: applicationDetailInfo.approveDate2 ? moment(applicationDetailInfo.approveDate2).format(formats.dateFormat) : '',
                      }
                    )
                  ),
                  m('.col-md-8',
                    m(`textarea#approveRemarks2.form-control.form-control-bg`,
                      {
                        placeholder: this.getText('LT00001321', 'Approval Remarks 2'),
                        disabled: checkEditLvl3(),
                        maxlength: 1000,
                        value: applicationDetailInfo.approveRemarks2,
                        onchange: (e) => { handleChange({ approveRemarks2: e.target.value }) }
                      }
                    )
                  ),
                  m('.col-md-4'),
                  m('.col-md-4.position-relative',
                    m('label.form-label.mandatory[for="fromChannelCode"]', this.getText('LT00001263', 'To Retail')),
                    m(SelectSiteSearchInputComponent, {
                      disabled: checkEditLvl1(),
                      required: true,
                      multiple: false,
                      selectedItem: { siteId: applicationDetailInfo.channelCode, siteName: applicationDetailInfo.channelName },
                      onSelect: (sites) => {
                        handleChange({ 'channelCode': sites.siteId, 'channelName': sites.siteName })
                        goodMovementModel.getChannelGoodsQty({ channelCode: sites.siteId, basicModelId: applicationDetailInfo.goodsId })
                          .then((result) => {
                            handleChange({ 'channelStockQty': result.qty });
                          }).catch((error) => {
                            this.handleError(error);
                          })
                      }
                    }),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                  ),
                  m('.col-md-2.position-relative',
                    m('label.form-label[for="retailQty"]', this.getText('LT00001260', 'Retail Qty')),
                    m(`input#retailQty.form-control.form-control-bg[type=number][placeholder=${this.getText('LT00001260', 'Retail Qty')}]`, {
                      readonly: true,
                      disabled: true,
                      value: applicationDetailInfo.channelStockQty,
                    }
                    ),
                  ),
                  m('.col-md-2.position-relative',
                    m('label.form-label.mandatory[for="qty"]',
                      this.getText('LT00001283', 'Qty')
                    ),
                    m(QtyNumberInputComponent, {
                      placeholder: this.getText('LT00001283', 'Qty'),
                      required: true,
                      disabled: checkEditLvl1(),
                      min: 1,
                      max: maxQty,
                      value: applicationDetailInfo.movementQty,
                      onChange: (value) => { handleChange({ movementQty: value }) },
                    }),
                  ),
                  m('.col-md-8.position-relative',
                    m('label.form-label.[for="fileInput1"]',
                      this.getText('LT00001248', 'Proof 1')
                    ),
                    m(FileUploadInputComponent, {
                      disabled: checkEditLvl1() || applicationDetailInfo.fileId1,
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      onInput: (uploadedFile) => {
                        fileInputs[1] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    applicationDetailInfo.fileId1 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: applicationDetailInfo.fileName1,
                        onclick: () => {
                          downloadProofFile(applicationDetailInfo.fileId1, applicationDetailInfo.fileName1)
                        }
                      }, applicationDetailInfo.fileName1),
                      !checkEditLvl1() && m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange({ fileId1: null, fileName1: null });
                          },
                          size: 'lg',
                        })
                      )
                    ]

                  ),
                  m('.col-md-8',
                    m('label.form-label[for="fileInput2"]',
                      this.getText('LT00001249', 'Proof 2')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: checkEditLvl1() || applicationDetailInfo.fileId2,
                      onInput: (uploadedFile) => {
                        fileInputs[2] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    applicationDetailInfo.fileId2 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: applicationDetailInfo.fileName2,
                        onclick: () => {
                          downloadProofFile(applicationDetailInfo.fileId2, applicationDetailInfo.fileName2)
                        }
                      }, applicationDetailInfo.fileName2),
                      !checkEditLvl1() && m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange({ fileId2: null, fileName2: null });
                          },
                          size: 'lg',
                        })
                      )
                    ]

                  ),
                  m('.col-md-8',
                    m('label.form-label[for="fileInput3"]',
                      this.getText('LT00001250', 'Proof 3')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: checkEditLvl1() || applicationDetailInfo.fileId3,
                      onInput: (uploadedFile) => {
                        fileInputs[3] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    applicationDetailInfo.fileId3 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: applicationDetailInfo.fileName3,
                        onclick: () => {
                          downloadProofFile(applicationDetailInfo.fileId3, applicationDetailInfo.fileName3)
                        }
                      }, applicationDetailInfo.fileName3),
                      !checkEditLvl1() && m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange({ fileId3: null, fileName3: null });
                          },
                          size: 'lg',
                        })
                      )
                    ]

                  ),
                  m('.col-md-8',
                    m('label.form-label[for="fileInput4"]',
                      this.getText('LT00001251', 'Proof 4')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: checkEditLvl1() || applicationDetailInfo.fileId4,
                      onInput: (uploadedFile) => {
                        fileInputs[4] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    applicationDetailInfo.fileId4 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: applicationDetailInfo.fileName4,
                        onclick: () => {
                          downloadProofFile(applicationDetailInfo.fileId4, applicationDetailInfo.fileName4)
                        }
                      }, applicationDetailInfo.fileName4),
                      !checkEditLvl1() && m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange({ fileId4: null, fileName4: null });
                          },
                          size: 'lg',
                        })
                      )
                    ]
                  ),
                  m('.col-md-8',
                    m('label.form-label[for="fileInput5"]',
                      this.getText('LT00001252', 'Proof 5')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: checkEditLvl1() || applicationDetailInfo.fileId5,
                      onInput: (uploadedFile) => {
                        fileInputs[5] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    applicationDetailInfo.fileId5 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: applicationDetailInfo.fileName5,
                        onclick: () => {
                          downloadProofFile(applicationDetailInfo.fileId5, applicationDetailInfo.fileName5)
                        }
                      }, applicationDetailInfo.fileName5),
                      !checkEditLvl1() && m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange({ fileId5: null, fileName5: null });
                          },
                          size: 'lg',
                        })
                      )
                    ]

                  ),
                  m('.col-md-8',
                    m('label.form-label[for="remarks"]',
                      this.getText('LT00000152', 'Remarks')
                    ),
                    m(`textarea#remarks.form-control.form-control-bg`,
                      {
                        placeholder: this.getText('LT00000152', 'Remarks'),
                        disabled: checkEditLvl1(),
                        maxlength: 1000,
                        value: applicationDetailInfo.remarks,
                        onchange: (e) => { handleChange({ remarks: e.target.value }) }
                      }
                    )
                  )
                )
              )
            )
          ),
          this.getBaseViews()
        ],

        footer: m('.row',
          m('.col-12.gap-2.d-flex.justify-content-end',
            POSMAuthorizationModel.loadWithPOSMAuthority([
              m('button.btn.btn-danger',
                {
                  type: 'button',
                  disabled: checkEditLvl1(),
                  name: APPROVAL_ACTIONS.DELETE,
                  value: APPROVAL_ACTIONS.DELETE,
                  onclick: (e) => { showDeleteMessage(e, onClose) },
                },
                m("i.bi.bi-trash-fill"),
                this.getText('LT00000135', 'Delete')
              ),
              m('button.btn.btn-primary',
                {
                  type: 'submit',
                  disabled: checkEditLvl1(),
                  name: APPROVAL_SAVES.SAVE,
                  value: APPROVAL_SAVES.SAVE,
                  onclick: onSubmitButtonsClick,
                  form: UPDATE_GOODS_APPLICATION_FORM_ID
                },
                m("i.bi.bi-pencil-square"),
                this.getText('LT00000022', 'Save')
              ),
              m('button.btn.btn-primary',
                {
                  type: 'submit',
                  disabled: checkEditLvl1(),
                  name: APPROVAL_SAVES.SUBMIT,
                  value: APPROVAL_SAVES.SUBMIT,
                  onclick: onSubmitButtonsClick,
                  form: UPDATE_GOODS_APPLICATION_FORM_ID
                },
                m("i.bi.bi-floppy-fill"),
                this.getText('LT00000005', 'Submit')
              ),
              m('button.btn.btn-success',
                {
                  type: 'submit',
                  disabled: checkEditLvl2(),
                  name: APPROVAL_ACTIONS.APPROVE,
                  value: APPROVAL_ACTIONS.APPROVE,
                  onclick: onSubmitButtonsClick,
                  form: UPDATE_GOODS_APPLICATION_FORM_ID
                },
                m("i.bi.bi-file-earmark-check-fill"),
                this.getText('LT00000185', 'Approve')
              ),
              m('button.btn.btn-success',
                {
                  type: 'submit',
                  disabled: checkEditLvl3(),
                  name: APPROVAL_ACTIONS.APPROVE2,
                  value: APPROVAL_ACTIONS.APPROVE2,
                  onclick: onSubmitButtonsClick,
                  form: UPDATE_GOODS_APPLICATION_FORM_ID
                },
                m("i.bi.bi-file-earmark-check-fill"),
                this.getText('LT00000185', 'Approve') + ' 2'
              ),
              m('button.btn.btn-danger',
                {
                  type: 'submit',
                  disabled: checkEditLvl2() && checkEditLvl3(),
                  name: APPROVAL_ACTIONS.REJECT,
                  value: APPROVAL_ACTIONS.REJECT,
                  onclick: onSubmitButtonsClick,
                  form: UPDATE_GOODS_APPLICATION_FORM_ID
                },
                m("i.bi.bi-file-earmark-x-fill"),
                this.getText('LT00000184', 'Reject')
              )
            ], POSM_PERMISSION_KEY.GOODS_ISSUE_APPLICATION),
            m('button.btn.btn-white',
              {
                type: 'button',
                onclick: onClose,
              },
              this.getText('LT00000021', 'Close')
            )
          )
        ),
      })
      ]
    }
  }
}
export default UpdatePOSMGoodsIssueApplicationDialog